export const getAutoHeightDuration = (height: number): number => {
  if (!height) return 0;
  const constant = height / 36;

  return Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10) / 1000;
};
